// Messages for the operator shell chrome (auto-merged by lib/i18n.ts).
export const en = {
  'operator.shell.subtitle': 'Operator',
  'operator.section.operations': 'Operations',
  'operator.section.marketing': 'Marketing',
  'operator.section.administration': 'Administration',
  'operator.nav.quotes': 'Quotes',
  'operator.nav.quote_requests': 'Quote requests',
  'operator.nav.customers': 'Customers',
  'operator.nav.conversations': 'Conversations',
  'operator.nav.invoices': 'Invoices',
  'operator.nav.contact_submissions': 'Contact form',
  'operator.shell.search': 'Search shipments, quotes, companies…',
  'operator.impersonation_banner.acting': 'Acting as {email}',
  'operator.impersonation_banner.until': '· until {time}',
  'operator.impersonation_banner.exit': 'Exit impersonation',
}

export const zhTW = {
  'operator.shell.subtitle': '營運人員',
  'operator.section.operations': '營運',
  'operator.section.marketing': '行銷',
  'operator.section.administration': '管理',
  'operator.nav.quotes': '報價',
  'operator.nav.quote_requests': '報價申請',
  'operator.nav.customers': '客戶',
  'operator.nav.conversations': '對話',
  'operator.nav.invoices': '發票',
  'operator.nav.contact_submissions': '聯絡表單',
  'operator.shell.search': '搜尋貨件、報價、公司…',
  'operator.impersonation_banner.acting': '正以 {email} 的身分操作',
  'operator.impersonation_banner.until': '· 至 {time}',
  'operator.impersonation_banner.exit': '結束模擬',
}
